'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useParticipant } from '@/lib/participant-auth/context';
import { rumUserForAthlete } from '@/lib/datadog/identity';

/** Tells RUM which athlete this is, by opaque id only (no personal data). */
export function DatadogIdentifyHub() {
  const participant = useParticipant();
  const participantId = participant?.id ?? null;

  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) return;

    if (!participantId) {
      datadogRum.clearUser();
      return;
    }

    datadogRum.setUser({ ...rumUserForAthlete({ id: participantId }) });
  }, [participantId]);

  return null;
}
